import { Box } from "@mui/material";
import { SaveDraftNoDraftsFilterWrapper } from "./SaveDraftNoDraftsFilterWrapper.styles";

export interface SaveDraftTemplateModalDetailsInterface {
	SaveTableDisclaimerText?: string;
	NoSaveFoundHeader: string;
	NoSaveListSubheader: string;
	NoSaveFoundFirstBullet?: string;
	NoSaveFoundSecondBullet?: string;
	NoSaveFoundThirdBullet?: string;
	NoSaveListFooter: string;
}

interface SaveDraftNoDraftFilterProps {
	SaveDraftTemplateModalDetails: SaveDraftTemplateModalDetailsInterface;
}

const SaveDraftNoDraftsFilter = ({ SaveDraftTemplateModalDetails }: SaveDraftNoDraftFilterProps) => {
	return (
		<SaveDraftNoDraftsFilterWrapper>
			<Box>
				<img
					src="/assets/NoOrdersSadBoxImage.svg"
					alt="No Orders Banner"
				/>
				<h6 data-testid="no-save-draft-orders-filter-header">
					{SaveDraftTemplateModalDetails.NoSaveFoundHeader}
				</h6>
				<div data-testid="no-save-draft-orders-filter-subheader">
					{SaveDraftTemplateModalDetails.NoSaveListSubheader}
				</div>
				<ul>
					{SaveDraftTemplateModalDetails.NoSaveFoundFirstBullet && (
						<li>{SaveDraftTemplateModalDetails.NoSaveFoundFirstBullet}</li>
					)}
					{SaveDraftTemplateModalDetails.NoSaveFoundSecondBullet && (
						<li>{SaveDraftTemplateModalDetails.NoSaveFoundSecondBullet}</li>
					)}
					{SaveDraftTemplateModalDetails.NoSaveFoundThirdBullet && (
						<li>{SaveDraftTemplateModalDetails.NoSaveFoundThirdBullet}</li>
					)}
				</ul>
			</Box>
			<div data-testid="no-save--orders-filter-footer">{SaveDraftTemplateModalDetails.NoSaveListFooter}</div>
		</SaveDraftNoDraftsFilterWrapper>
	);
};

export default SaveDraftNoDraftsFilter;
